import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// ===== IMPORTS DE COMPONENTES =====
// Páginas principales
import Homepage from "./Homepage";
import Contacto from "./contacto";
import Blog from "./blog";
import LoginAsesor from "./login";

// Calculadoras
import CNegocio from "./Calculadoras/CalculadoraNegocio";
import CRetiro from "./Calculadoras/CalculadoraRetiro";
import CVivienda from "./Calculadoras/CalculadoraVivienda";
import CEducacion from "./Calculadoras/CalculadoraEducacion";
import CEventoEspecial from "./Calculadoras/CalculadoraEventoEspecial";
import CConocerMundo from "./Calculadoras/CalculadoraConocerMundo";
import CFondoSalud from "./Calculadoras/CalculadoraFondoSalud";
import CLegadoFinanciero from "./Calculadoras/CalculadoraLegadoFinanciero";
import CRenovacion from "./Calculadoras/CalculadoraRenovacion";
import CSabatico from "./Calculadoras/CalculadoraSabatico";
import CSoloAhorrar from "./Calculadoras/CalculadoraSoloAhorrar";

// Hubs
import CalculadorasHub from "./CalculadorasHub";
import ServiciosHub from "./ServiciosHub";

// Seguros
import SeguroDeAuto from "./Seguros/SeguroDeAuto";
import SeguroDeGastosMedicosMayores from "./Seguros/SeguroDeGastosMedicosMayores";
import SeguroDelHogar from "./Seguros/SeguroDelHogar";
import SeguroDeViajes from "./Seguros/SeguroDeViajes";
import SeguroDeVida from "./Seguros/SeguroDeVida";

// Administración
import CitaForm from "./pantallacita";
import CitasClientes from "./administracion";
import CitasDespues from "./citasdespues";
import AdministrarSeguros from "./adminseguros";
import HorariosAdmin from "./HorariosAdmin";
import BlogAdmin from "./BlogAdmin";
import Aiuda from "./aiuda";
import UploadImage from "./UploadImage";

// Componentes compartidos
import DisplayCalculo from "./DisplayCalculo";
import Rutasegura from "./Rutasegura";

// ===== COMPONENTE PRINCIPAL =====
function App() {
  return (
    <Routes>
      {/* ===== RUTAS PÚBLICAS ===== */}
      <Route path="/" element={<Homepage />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/Login" element={<LoginAsesor />} />
      <Route path="/upload-image" element={<UploadImage />} />

      {/* ===== CALCULADORAS ===== */}
      <Route path="/CalculadoraConocerMundo" element={<CConocerMundo />} />
      <Route path="/CalculadoraEducacion" element={<CEducacion />} />
      <Route path="/CalculadoraEventoEspecial" element={<CEventoEspecial />} />
      <Route path="/CalculadoraFondoSalud" element={<CFondoSalud />} />
      <Route path="/CalculadoraLegadoFinanciero" element={<CLegadoFinanciero />} />
      <Route path="/CalculadoraNegocio" element={<CNegocio />} />
      <Route path="/CalculadoraRenovacion" element={<CRenovacion />} />
      <Route path="/CalculadoraRetiro" element={<CRetiro />} />
      <Route path="/CalculadoraSabatico" element={<CSabatico />} />
      <Route path="/CalculadoraSoloAhorrar" element={<CSoloAhorrar />} />
      <Route path="/CalculadoraVivienda" element={<CVivienda />} />

      {/* ===== HUBS ===== */}
      <Route path="/CalculadorasDisplay" element={<CalculadorasHub />} />
      <Route path="/ServiciosDisplay" element={<ServiciosHub />} />

      {/* ===== SEGUROS ===== */}
      <Route path="/SeguroDeAuto" element={<SeguroDeAuto />} />
      <Route path="/SeguroDeGastosMedicosMayores" element={<SeguroDeGastosMedicosMayores />} />
      <Route path="/SeguroDelHogar" element={<SeguroDelHogar />} />
      <Route path="/SeguroDeViajes" element={<SeguroDeViajes />} />
      <Route path="/SeguroDeVida" element={<SeguroDeVida />} />

      {/* ===== CITAS Y FORMULARIOS ===== */}
      <Route path="/PantallaCIT" element={<CitaForm />} />
      <Route path="/DisplayCalculo" element={<DisplayCalculo />} />

      {/* ===== RUTAS PROTEGIDAS ===== */}
      <Route path="/citasdespues" element={
        <Rutasegura>
          <CitasDespues />
        </Rutasegura>
      } />
      
      <Route path="/administracion" element={
        <Rutasegura>
          <CitasClientes />
        </Rutasegura>
      } />
      
      <Route path="/adminseguros" element={
        <Rutasegura>
          <AdministrarSeguros />
        </Rutasegura>
      } />
      
      <Route path="/CitasClientes" element={
        <Rutasegura>
          <CitasClientes />
        </Rutasegura>
      } />
      
      <Route path="/horariosadmin" element={
        <Rutasegura>
          <HorariosAdmin />
        </Rutasegura>
      } />
      
      <Route path="/adminblog" element={
        <Rutasegura>
          <BlogAdmin />
        </Rutasegura>
      } />
      
      <Route path="/aiuda" element={
        <Rutasegura>
          <Aiuda />
        </Rutasegura>
      } />
    </Routes>
  );
}

// ===== ROUTER PRINCIPAL =====
export default function RouterApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}